/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';

export default tagTester('String');




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isString.js
// module id = 39
// module chunks = 0